(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('.filtru-info[data-phone]');
    if (!wrapper) return;

    var phone = wrapper.getAttribute('data-phone');
    var baseMessage = wrapper.getAttribute('data-message') || 'Buna! As dori informatii despre filtre.';

    var h1 = document.querySelector('h1');
    var productTitle = h1 ? h1.innerText.trim() : '';

    var message = productTitle
      ? baseMessage + ' Produs: "' + productTitle + '".'
      : baseMessage;

    var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);

    var btn = document.getElementById('filtruWhatsappBtn');
    if (btn) btn.setAttribute('href', url);
  });
})();